import { LocalStorageAdapter } from '@/infra/cache'
import { EnumStorageKeys } from '@/data/protocols/cache'

let sessionId: string | null = null

const getStorage = () => new LocalStorageAdapter()

export const getSessionId = () =>
  sessionId || (sessionId = getStorage().get(EnumStorageKeys.SESSION_ID))

export const createNewSessionId = () => {
  sessionId = new Date().getTime().toString()
  getStorage().set(EnumStorageKeys.SESSION_ID, sessionId)
  return sessionId
}

export const getOrCreateSessionId = () => getSessionId() || createNewSessionId()

export const clearSessionId = () => {
  sessionId = null
  getStorage().set(EnumStorageKeys.SESSION_ID, undefined)
}
